import { useState } from 'react'
import { CardModal, Type } from '@/components/common'
import { Question } from '@/components/svg'

const Buffer = ({ campaign, className = '' }) => {
  const [showModal, setShowModal] = useState(false)
  const showBuffer = campaign.isInBuffer

  if (!showBuffer) {
    return null
  }

  return (
    <>
      <div className={className}>
        <div
          onClick={() => setShowModal(true)}
          className="md:text-lg flex cursor-pointer flex-row gap-1 text-md"
        >
          <span>Why are we still taking investments?</span>
          <Question className="mt-1 w-8 md:w-auto" />
        </div>
      </div>

      <CardModal isOpen={showModal} setIsOpen={setShowModal}>
        <CardModal.Header>Investment Maximum Reached</CardModal.Header>
        <CardModal.Body>
          <Type variant="paragraph-sm" as="p">
            We have reached our investment maximum. However, due to the nature
            of processing the funds, it is possible that some investments are
            never completed or are cancelled. If you commit now, even though the
            offering is full, if enough other investments drop out before
            closing, your commitment may move forward in line within the limit.
            If so, we will notify you that your investment commitment closed. If
            you do not make it into the round, we will refund your money and
            send a notice.
          </Type>
        </CardModal.Body>
      </CardModal>
    </>
  )
}

export default Buffer
